import { S2SState } from './state';

export const UPDATE_OPEN_PACKAGE_SUB_DRAWER = (state: S2SState, value: number) => {
  state.openPackageSubDrawerId = value;
};

export const UPDATE_IS_UPLOADING_TAGS = (state: S2SState, value: boolean) => {
  state.isUploadingTags = value;
};
